import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HeatRank from "./components/HeatRank";
import MomentGallery from "./components/MomentGallery";
import StatBand from "./components/StatBand";
import Archive from "./components/Archive";
import TopicShell from "./components/TopicShell";
import JoinCta from "./components/JoinCta";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 text-foreground-950">
      <Navbar />
      <main id="scene">
        <Hero />
        <HeatRank />
        <MomentGallery />
        <StatBand />
        <Archive />
        <TopicShell />
        <JoinCta />
      </main>
      <Footer />
    </div>
  );
}